import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { PeriodPipe } from './pipes/period.pipe';
import { LayoutService } from './services/layout.service';
import { SafePipe, PricePipe, SortPipe } from '@apps/ui';
import { RwdImagePipe } from './pipes/rwd-image.pipe';
import { FirstLetterPipe } from './pipes/first-letter.pipe';
import { ComponentNamePipe } from './pipes/component-name.pipe';
import { ComponentTypePipe } from './pipes/component-type.pipe';

const pipes = [
  SafePipe,
  PricePipe,
  PeriodPipe,
  RwdImagePipe,
  FirstLetterPipe,
  SortPipe,
  ComponentNamePipe,
  ComponentTypePipe
];

@NgModule({
  declarations: [...pipes],
  imports: [CommonModule, HttpClientModule],
  exports: [CommonModule, HttpClientModule, ...pipes],
  providers: [CurrencyPipe, LayoutService]
})
export class SharedModule {}
